import { createFileRoute } from "@tanstack/react-router";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { useAuth } from "../../auth";
import { useDocumentTitle } from "@/lib/document-title";

export const Route = createFileRoute("/_app/onboarding")({
  component: OnboardingPage,
});

function OnboardingPage() {
  useDocumentTitle(["Get started"]);
  const auth = useAuth();

  return (
    <div className="mx-auto h-full max-w-[560px] overflow-auto px-6 py-12">
      <header className="mb-6 flex flex-col gap-1">
        <p className="meta-strip">Welcome</p>
        <h1 className="text-3xl font-semibold tracking-tight">Chaidojo</h1>
        <p className="text-sm text-muted-foreground">You don't belong to any organisation yet.</p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Create your first org</CardTitle>
          <CardDescription>
            For now, orgs are tied to signup. Sign out and re-signup with the "Create an org"
            option, or paste an invite token in your email.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Alert>
            <AlertTitle>Tip</AlertTitle>
            <AlertDescription>
              Phase 2 will let you create orgs after sign-in. For now, the cleanest path is to sign
              out and re-create your account choosing
              <em> Create an org</em>.
            </AlertDescription>
          </Alert>
        </CardContent>
        <CardFooter className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={async () => {
              await auth.logout();
              // Hard reload — same rationale as the AppSidebar logout:
              // SPA navigation races against the cleared cookie + the
              // signin route's auto-redirect effect (#8).
              window.location.assign("/signup");
            }}
          >
            Sign out → re-signup
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
